import { CollectionChildNodeType } from 'src/io/models/collection-child-node-type'
import { defaultCollectionRequestParams } from './default-collection-request-params'
import { CollectionChildNodesRequestParams } from 'src/io/models/http/collection-child-nodes-request-params'

export const defaultCollectionChildNodesRequestParams: CollectionChildNodesRequestParams = {
  ...defaultCollectionRequestParams,
  type: 'event' as CollectionChildNodeType
}
